import React from 'react';
import AppList from './app-list';

var pickApps = function pickApps(apps, names) {
  return names.map(function (name) {
    return apps.find(function (app) {
      return app.name === name;
    });
  });
};

var CategorizedAppList = function CategorizedAppList(_ref) {
  var t = _ref.t,
      ns = _ref.ns,
      categories = _ref.categories,
      apps = _ref.apps,
      consents = _ref.consents,
      onToggle = _ref.onToggle;
  return React.createElement("ul", {
    className: ns('CategorizedAppList')
  }, categories.map(function (_ref2) {
    var name = _ref2.name,
        title = _ref2.title,
        description = _ref2.description,
        appNames = _ref2.apps;
    return React.createElement("li", {
      className: ns('CategorizedAppList-item')
    }, React.createElement("h2", {
      className: ns('CategorizedAppList-title')
    }, t(['categories', name, 'title']) || title), React.createElement("p", {
      className: ns('CategorizedAppList-description')
    }, t(['categories', name, 'description']) || description), React.createElement("div", {
      className: ns('CategorizedAppList-apps')
    }, React.createElement(AppList, {
      t: t,
      ns: ns,
      apps: pickApps(apps, appNames),
      consents: consents,
      onToggle: onToggle
    })));
  }));
};

export default CategorizedAppList;